import React from "react";
import Layout from "../components/Layout";
import { Link } from "react-router-dom";

const Home = () => {
    return (
        <Layout>
            <div className="home">
                <div className="container">
                    <div className="home__links d-flex">
                        <Link className="home__title" to="/indicators">Индикаторы</Link>
                        <Link className="home__title" to="/form">Анкета</Link>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Home;